import AppLayout from '../Layout/AppLayout';
import GestionDemandes from '../Components/Demandes/GestionDemandes';

const Demandes = () => {
    return (
        <AppLayout>
            <GestionDemandes />
        </AppLayout>
    );
};

export default Demandes;
